/**
 * Checks if a value from URL is different from the value stored in an object.
 *
 * @param  {String} fromObject - value from object.
 * @param  {String} fromUrl - value from URL.
 * @return {Object}
 */
export default function checkValue(fromObject, fromUrl) {
  if (fromUrl && (fromObject !== fromUrl)) {
    return { value: fromUrl, changed: true };
  }
  return { value: fromObject, changed: false };
}
